const gremio = [
  {
    id: 1,
    pais: "brasil",
    liga: "serie-a",
    time: "gremio",
    nome: "Grêmio 25/26 - Uniforme 1",
    aliases: [
      "gremio",
      "grêmio",
      "tricolor",
      "imortal",
      "2025",
      "gremio 2025",
      "grêmio 2025",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/gremio/25-26-01/uni0.jpg",
      "/images/brasil/serie-a/gremio/25-26-01/uni1.jpg",
      "/images/brasil/serie-a/gremio/25-26-01/uni2.jpg",
      "/images/brasil/serie-a/gremio/25-26-01/uni3.jpg",
      "/images/brasil/serie-a/gremio/25-26-01/uni4.jpg",
    ],
  },
  {
    id: 2,
    pais: "brasil",
    liga: "serie-a",
    time: "gremio",
    nome: "Grêmio 25/26 - Uniforme 1 Manga Longa",
    aliases: [
      "gremio",
      "grêmio",
      "tricolor",
      "imortal",
      "2025",
      "gremio 2025",
      "grêmio 2025",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/gremio/25-26-01-mc/uni0.jpg",
      "/images/brasil/serie-a/gremio/25-26-01-mc/uni1.jpg",
      "/images/brasil/serie-a/gremio/25-26-01-mc/uni2.jpg",
      "/images/brasil/serie-a/gremio/25-26-01-mc/uni3.jpg",
      "/images/brasil/serie-a/gremio/25-26-01-mc/uni4.jpg",
    ],
  },
  {
    id: 3,
    pais: "brasil",
    liga: "serie-a",
    time: "gremio",
    nome: "Grêmio 25/26 - Uniforme 2",
    aliases: [
      "gremio",
      "grêmio",
      "tricolor",
      "imortal",
      "2025",
      "gremio 2025",
      "grêmio 2025",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/gremio/25-26-02/uni0.jpg",
      "/images/brasil/serie-a/gremio/25-26-02/uni1.jpg",
      "/images/brasil/serie-a/gremio/25-26-02/uni2.jpg",
      "/images/brasil/serie-a/gremio/25-26-02/uni3.jpg",
      "/images/brasil/serie-a/gremio/25-26-02/uni4.jpg",
    ],
  },
  {
    id: 4,
    pais: "brasil",
    liga: "serie-a",
    time: "gremio",
    nome: "Grêmio 25/26 - Uniforme 3",
    aliases: [
      "gremio",
      "grêmio",
      "tricolor",
      "imortal",
      "2025",
      "gremio 2025",
      "grêmio 2025",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/gremio/25-26-03/uni0.jpg",
      "/images/brasil/serie-a/gremio/25-26-03/uni1.jpg",
      "/images/brasil/serie-a/gremio/25-26-03/uni2.jpg",
      "/images/brasil/serie-a/gremio/25-26-03/uni3.jpg",
      "/images/brasil/serie-a/gremio/25-26-03/uni4.jpg",
    ],
  },
  {
    id: 5,
    pais: "brasil",
    liga: "serie-a",
    time: "gremio",
    nome: "Grêmio 25/26 - Uniforme 3 (Feminino)",
    aliases: [
      "gremio",
      "grêmio",
      "tricolor",
      "imortal",
      "2025",
      "gremio 2025",
      "grêmio 2025",
      "grêmio feminino",
      "feminino grêmio",
      "feminino",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/gremio/25-26-03/uni0.jpg",
      "/images/brasil/serie-a/gremio/25-26-03/uni1.jpg",
      "/images/brasil/serie-a/gremio/25-26-03/uni2.jpg",
      "/images/brasil/serie-a/gremio/25-26-03/uni3.jpg",
      "/images/brasil/serie-a/gremio/25-26-03/uni4.jpg",
    ],
  },
  {
    id: 6,
    pais: "brasil",
    liga: "serie-a",
    time: "gremio",
    nome: "Grêmio 24/25 - Uniforme 1",
    aliases: [
      "gremio",
      "grêmio",
      "tricolor",
      "imortal",
      "2024",
      "gremio 2024",
      "grêmio 2024",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/gremio/24-25-01/uni0.jpg",
      "/images/brasil/serie-a/gremio/24-25-01/uni1.jpg",
      "/images/brasil/serie-a/gremio/24-25-01/uni2.jpg",
      "/images/brasil/serie-a/gremio/24-25-01/uni3.jpg",
      "/images/brasil/serie-a/gremio/24-25-01/uni4.jpg",
    ],
  },
  {
    id: 7,
    pais: "brasil",
    liga: "serie-a",
    time: "gremio",
    nome: "Grêmio 24/25 - Uniforme 2",
    aliases: [
      "gremio",
      "grêmio",
      "tricolor",
      "imortal",
      "2024",
      "gremio 2024",
      "grêmio 2024",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/gremio/24-25-02/uni0.jpg",
      "/images/brasil/serie-a/gremio/24-25-02/uni1.jpg",
      "/images/brasil/serie-a/gremio/24-25-02/uni2.jpg",
      "/images/brasil/serie-a/gremio/24-25-02/uni3.jpg",
      "/images/brasil/serie-a/gremio/24-25-02/uni4.jpg",
    ],
  },
  {
    id: 8,
    pais: "brasil",
    liga: "serie-a",
    time: "gremio",
    nome: "Grêmio 24/25 - Uniforme 3",
    aliases: [
      "gremio",
      "grêmio",
      "tricolor",
      "imortal",
      "2024",
      "gremio 2024",
      "grêmio 2024",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/gremio/24-25-03/uni0.png",
      "/images/brasil/serie-a/gremio/24-25-03/uni1.png",
    ],
  },
  {
    id: 9,
    pais: "brasil",
    liga: "serie-a",
    time: "gremio",
    nome: "Grêmio 24/25 - Uniforme 2 (Feminino)",
    aliases: [
      "gremio",
      "grêmio",
      "tricolor",
      "imortal",
      "2024",
      "gremio 2024",
      "grêmio 2024",
      "grêmio feminino",
      "feminino grêmio",
      "feminino",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/gremio/24-25-02-f/uni0.jpg",
      "/images/brasil/serie-a/gremio/24-25-02-f/uni1.jpg",
      "/images/brasil/serie-a/gremio/24-25-02-f/uni2.jpg",
      "/images/brasil/serie-a/gremio/24-25-02-f/uni3.jpg",
      "/images/brasil/serie-a/gremio/24-25-02-f/uni4.jpg",
    ],
  },
  {
    id: 10,
    pais: "brasil",
    liga: "serie-a",
    time: "gremio",
    nome: "Grêmio 24/25 - Uniforme de Treino (Azul)",
    aliases: [
      "gremio",
      "grêmio",
      "tricolor",
      "imortal",
      "2024",
      "gremio 2024",
      "grêmio 2024",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/gremio/24-25-05-ta/uni0.jpg",
      "/images/brasil/serie-a/gremio/24-25-05-ta/uni1.jpg",
      "/images/brasil/serie-a/gremio/24-25-05-ta/uni2.jpg",
      "/images/brasil/serie-a/gremio/24-25-05-ta/uni3.jpg",
      "/images/brasil/serie-a/gremio/24-25-05-ta/uni4.jpg",
    ],
  },
  {
    id: 11,
    pais: "brasil",
    liga: "serie-a",
    time: "gremio",
    nome: "Grêmio 24/25 - Uniforme de Treino (Azul)",
    aliases: [
      "gremio",
      "grêmio",
      "tricolor",
      "imortal",
      "2024",
      "gremio 2024",
      "grêmio 2024",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/gremio/24-25-05-ta2/uni0.jpg",
      "/images/brasil/serie-a/gremio/24-25-05-ta2/uni1.jpg",
      "/images/brasil/serie-a/gremio/24-25-05-ta2/uni2.jpg",
      "/images/brasil/serie-a/gremio/24-25-05-ta2/uni3.jpg",
    ],
  },
  {
    id: 12,
    pais: "brasil",
    liga: "serie-a",
    time: "gremio",
    nome: "Grêmio 24/25 - Uniforme de Treino",
    aliases: [
      "gremio",
      "grêmio",
      "tricolor",
      "imortal",
      "2024",
      "gremio 2024",
      "grêmio 2024",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/gremio/24-25-06-t/uni0.jpg",
      "/images/brasil/serie-a/gremio/24-25-06-t/uni1.jpg",
      "/images/brasil/serie-a/gremio/24-25-06-t/uni2.jpg",
      "/images/brasil/serie-a/gremio/24-25-06-t/uni3.jpg",
    ],
  },
  {
    id: 13,
    pais: "brasil",
    liga: "serie-a",
    time: "gremio",
    nome: "Grêmio 23/24 - Uniforme 1",
    aliases: [
      "gremio",
      "grêmio",
      "tricolor",
      "imortal",
      "2023",
      "gremio 2023",
      "grêmio 2023",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/gremio/23-24-01/uni0.jpg",
      "/images/brasil/serie-a/gremio/23-24-01/uni1.jpg",
      "/images/brasil/serie-a/gremio/23-24-01/uni2.jpg",
      "/images/brasil/serie-a/gremio/23-24-01/uni3.jpg",
      "/images/brasil/serie-a/gremio/23-24-01/uni4.jpg",
    ],
  },
  {
    id: 14,
    pais: "brasil",
    liga: "serie-a",
    time: "gremio",
    nome: "Grêmio 23/24 - Uniforme 2",
    aliases: [
      "gremio",
      "grêmio",
      "tricolor",
      "imortal",
      "2023",
      "gremio 2023",
      "grêmio 2023",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/gremio/23-24-02/uni0.jpg",
      "/images/brasil/serie-a/gremio/23-24-02/uni1.jpg",
      "/images/brasil/serie-a/gremio/23-24-02/uni2.jpg",
      "/images/brasil/serie-a/gremio/23-24-02/uni3.jpg",
      "/images/brasil/serie-a/gremio/23-24-02/uni4.jpg",
    ],
  },
  {
    id: 15,
    pais: "brasil",
    liga: "serie-a",
    time: "gremio",
    nome: "Grêmio 23/24 - Uniforme Edição Especial",
    aliases: [
      "gremio",
      "grêmio",
      "tricolor",
      "imortal",
      "2023",
      "gremio 2023",
      "grêmio 2023",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/gremio/23-24-00-es/uni0.jpg",
      "/images/brasil/serie-a/gremio/23-24-00-es/uni1.jpg",
      "/images/brasil/serie-a/gremio/23-24-00-es/uni2.jpg",
      "/images/brasil/serie-a/gremio/23-24-00-es/uni3.jpg",
      "/images/brasil/serie-a/gremio/23-24-00-es/uni4.jpg",
    ],
  },
  {
    id: 16,
    pais: "brasil",
    liga: "serie-a",
    time: "gremio",
    nome: "Grêmio 22/23 - Uniforme 1",
    aliases: [
      "gremio",
      "grêmio",
      "tricolor",
      "imortal",
      "2022",
      "gremio 2022",
      "grêmio 2022",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/gremio/22-23-01/uni0.jpg",
      "/images/brasil/serie-a/gremio/22-23-01/uni1.jpg",
      "/images/brasil/serie-a/gremio/22-23-01/uni2.jpg",
      "/images/brasil/serie-a/gremio/22-23-01/uni3.jpg",
      "/images/brasil/serie-a/gremio/22-23-01/uni4.jpg",
    ],
  },
  {
    id: 17,
    pais: "brasil",
    liga: "serie-a",
    time: "gremio",
    nome: "Grêmio 22/23 - Uniforme 3",
    aliases: [
      "gremio",
      "grêmio",
      "tricolor",
      "imortal",
      "2022",
      "gremio 2022",
      "grêmio 2022",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/gremio/22-23-03/uni0.jpg",
      "/images/brasil/serie-a/gremio/22-23-03/uni1.jpg",
      "/images/brasil/serie-a/gremio/22-23-03/uni2.jpg",
      "/images/brasil/serie-a/gremio/22-23-03/uni3.jpg",
      "/images/brasil/serie-a/gremio/22-23-03/uni4.jpg",
    ],
  },
  {
    id: 18,
    pais: "brasil",
    liga: "serie-a",
    time: "gremio",
    nome: "Grêmio 22/23 - Uniforme Edição Especial",
    aliases: [
      "gremio",
      "grêmio",
      "tricolor",
      "imortal",
      "2022",
      "gremio 2022",
      "grêmio 2022",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/gremio/22-23-00-esr/uni0.jpg",
      "/images/brasil/serie-a/gremio/22-23-00-esr/uni1.jpg",
      "/images/brasil/serie-a/gremio/22-23-00-esr/uni2.jpg",
      "/images/brasil/serie-a/gremio/22-23-00-esr/uni3.jpg",
      "/images/brasil/serie-a/gremio/22-23-00-esr/uni4.jpg",
    ],
  },
  {
    id: 19,
    pais: "brasil",
    liga: "serie-a",
    time: "gremio",
    nome: "Grêmio 21/22 - Uniforme 1 Manga Longa",
    aliases: [
      "gremio",
      "grêmio",
      "tricolor",
      "imortal",
      "2021",
      "gremio 2021",
      "grêmio 2021",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/gremio/21-22-01-mc/uni0.jpg",
      "/images/brasil/serie-a/gremio/21-22-01-mc/uni1.jpg",
      "/images/brasil/serie-a/gremio/21-22-01-mc/uni2.jpg",
      "/images/brasil/serie-a/gremio/21-22-01-mc/uni3.jpg",
      "/images/brasil/serie-a/gremio/21-22-01-mc/uni4.jpg",
    ],
  },
  {
    id: 20,
    pais: "brasil",
    liga: "serie-a",
    time: "gremio",
    nome: "Grêmio 21/22 - Uniforme 2",
    aliases: [
      "gremio",
      "grêmio",
      "tricolor",
      "imortal",
      "2021",
      "gremio 2021",
      "grêmio 2021",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/gremio/21-22-02/uni0.jpg",
      "/images/brasil/serie-a/gremio/21-22-02/uni1.jpg",
      "/images/brasil/serie-a/gremio/21-22-02/uni2.jpg",
      "/images/brasil/serie-a/gremio/21-22-02/uni3.jpg",
      "/images/brasil/serie-a/gremio/21-22-02/uni4.jpg",
    ],
  },
  {
    id: 21,
    pais: "brasil",
    liga: "serie-a",
    time: "gremio",
    nome: "Grêmio 21/22 - Uniforme 3",
    aliases: [
      "gremio",
      "grêmio",
      "tricolor",
      "imortal",
      "2021",
      "gremio 2021",
      "grêmio 2021",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/gremio/21-22-03/uni0.jpg",
      "/images/brasil/serie-a/gremio/21-22-03/uni1.jpg",
      "/images/brasil/serie-a/gremio/21-22-03/uni2.jpg",
      "/images/brasil/serie-a/gremio/21-22-03/uni3.jpg",
      "/images/brasil/serie-a/gremio/21-22-03/uni4.jpg",
    ],
  },
  {
    id: 22,
    pais: "brasil",
    liga: "serie-a",
    time: "gremio",
    nome: "Grêmio 20/21 - Uniforme 1",
    aliases: [
      "gremio",
      "grêmio",
      "tricolor",
      "imortal",
      "2020",
      "gremio 2020",
      "grêmio 2020",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/gremio/20-21-01/uni0.jpg",
      "/images/brasil/serie-a/gremio/20-21-01/uni1.jpg",
      "/images/brasil/serie-a/gremio/20-21-01/uni2.jpg",
      "/images/brasil/serie-a/gremio/20-21-01/uni3.jpg",
      "/images/brasil/serie-a/gremio/20-21-01/uni4.jpg",
    ],
  },
  {
    id: 23,
    pais: "brasil",
    liga: "serie-a",
    time: "gremio",
    nome: "Grêmio 20/21 - Uniforme 1 (Feminino)",
    aliases: [
      "gremio",
      "grêmio",
      "tricolor",
      "imortal",
      "2021",
      "gremio 2021",
      "grêmio 2021",
      "grêmio feminino",
      "feminino grêmio",
      "feminino",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/gremio/20-21-01-f/uni0.jpg",
      "/images/brasil/serie-a/gremio/20-21-01-f/uni1.jpg",
      "/images/brasil/serie-a/gremio/20-21-01-f/uni2.jpg",
      "/images/brasil/serie-a/gremio/20-21-01-f/uni3.jpg",
      "/images/brasil/serie-a/gremio/20-21-01-f/uni4.jpg",
    ],
  },
  {
    id: 24,
    pais: "brasil",
    liga: "serie-a",
    time: "gremio",
    nome: "Grêmio 20/21 - Uniforme 2 (Feminino)",
    aliases: [
      "gremio",
      "grêmio",
      "tricolor",
      "imortal",
      "2021",
      "gremio 2021",
      "grêmio 2021",
      "grêmio feminino",
      "feminino grêmio",
      "feminino",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/gremio/20-21-02-f/uni0.jpg",
      "/images/brasil/serie-a/gremio/20-21-02-f/uni1.jpg",
      "/images/brasil/serie-a/gremio/20-21-02-f/uni2.jpg",
      "/images/brasil/serie-a/gremio/20-21-02-f/uni3.jpg",
    ],
  },
  {
    id: 25,
    pais: "brasil",
    liga: "serie-a",
    time: "gremio",
    nome: "Grêmio 16/17 - Uniforme 1 Retro",
    aliases: [
      "gremio",
      "grêmio",
      "tricolor",
      "imortal",
      "retro",
      "gremio retro",
      "grêmio retro",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/gremio/16-17-01-rt/uni0.jpg",
      "/images/brasil/serie-a/gremio/16-17-01-rt/uni1.jpg",
      "/images/brasil/serie-a/gremio/16-17-01-rt/uni2.jpg",
      "/images/brasil/serie-a/gremio/16-17-01-rt/uni3.jpg",
      "/images/brasil/serie-a/gremio/16-17-01-rt/uni4.jpg",
    ],
  },
  {
    id: 26,
    pais: "brasil",
    liga: "serie-a",
    time: "gremio",
    nome: "Grêmio 01/02 - Uniforme 1 Retro",
    aliases: [
      "gremio",
      "grêmio",
      "tricolor",
      "imortal",
      "retro",
      "gremio retro",
      "grêmio retro",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/gremio/01-02-01-rt/uni0.jpg",
      "/images/brasil/serie-a/gremio/01-02-01-rt/uni1.jpg",
      "/images/brasil/serie-a/gremio/01-02-01-rt/uni2.jpg",
      "/images/brasil/serie-a/gremio/01-02-01-rt/uni3.jpg",
      "/images/brasil/serie-a/gremio/01-02-01-rt/uni4.jpg",
    ],
  },
  {
    id: 27,
    pais: "brasil",
    liga: "serie-a",
    time: "gremio",
    nome: "Grêmio 00/01 - Uniforme 1 Retro",
    aliases: [
      "gremio",
      "grêmio",
      "tricolor",
      "imortal",
      "retro",
      "gremio retro",
      "grêmio retro",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/gremio/00-01-01-rt/uni0.jpg",
      "/images/brasil/serie-a/gremio/00-01-01-rt/uni1.jpg",
      "/images/brasil/serie-a/gremio/00-01-01-rt/uni2.jpg",
      "/images/brasil/serie-a/gremio/00-01-01-rt/uni3.jpg",
      "/images/brasil/serie-a/gremio/00-01-01-rt/uni4.jpg",
    ],
  },
  {
    id: 28,
    pais: "brasil",
    liga: "serie-a",
    time: "gremio",
    nome: "Grêmio 98/99 - Uniforme 1 Retro",
    aliases: [
      "gremio",
      "grêmio",
      "tricolor",
      "imortal",
      "retro",
      "gremio retro",
      "grêmio retro",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/gremio/98-99-01-rt/uni0.jpg",
      "/images/brasil/serie-a/gremio/98-99-01-rt/uni1.jpeg",
      "/images/brasil/serie-a/gremio/98-99-01-rt/uni2.jpg",
      "/images/brasil/serie-a/gremio/98-99-01-rt/uni3.jpg",
      "/images/brasil/serie-a/gremio/98-99-01-rt/uni4.jpg",
    ],
  },
  {
    id: 29,
    pais: "brasil",
    liga: "serie-a",
    time: "gremio",
    nome: "Grêmio 97/98 - Uniforme 1 Retro",
    aliases: [
      "gremio",
      "grêmio",
      "tricolor",
      "imortal",
      "retro",
      "gremio retro",
      "grêmio retro",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/gremio/97-98-01-rt/uni0.jpg",
      "/images/brasil/serie-a/gremio/97-98-01-rt/uni1.jpg",
      "/images/brasil/serie-a/gremio/97-98-01-rt/uni2.jpg",
      "/images/brasil/serie-a/gremio/97-98-01-rt/uni3.jpg",
      "/images/brasil/serie-a/gremio/97-98-01-rt/uni4.jpg",
    ],
  },
  {
    id: 30,
    pais: "brasil",
    liga: "serie-a",
    time: "gremio",
    nome: "Grêmio 96/97 - Uniforme 3 Retro",
    aliases: [
      "gremio",
      "grêmio",
      "tricolor",
      "imortal",
      "retro",
      "gremio retro",
      "grêmio retro",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/gremio/96-97-03-rt/uni0.png",
      "/images/brasil/serie-a/gremio/96-97-03-rt/uni1.png",
      "/images/brasil/serie-a/gremio/96-97-03-rt/uni2.png",
      "/images/brasil/serie-a/gremio/96-97-03-rt/uni3.png",
      "/images/brasil/serie-a/gremio/96-97-03-rt/uni4.png",
    ],
  },
  {
    id: 31,
    pais: "brasil",
    liga: "serie-a",
    time: "gremio",
    nome: "Grêmio 95/96 - Uniforme 1 Retro",
    aliases: [
      "gremio",
      "grêmio",
      "tricolor",
      "imortal",
      "retro",
      "gremio retro",
      "grêmio retro",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/gremio/95-96-01-rt/uni0.jpg",
      "/images/brasil/serie-a/gremio/95-96-01-rt/uni1.jpg",
      "/images/brasil/serie-a/gremio/95-96-01-rt/uni2.jpg",
      "/images/brasil/serie-a/gremio/95-96-01-rt/uni3.jpg",
      "/images/brasil/serie-a/gremio/95-96-01-rt/uni4.jpg",
    ],
  },
  {
    id: 32,
    pais: "brasil",
    liga: "serie-a",
    time: "gremio",
    nome: "Grêmio 94/95 - Uniforme 2 Retro",
    aliases: [
      "gremio",
      "grêmio",
      "tricolor",
      "imortal",
      "retro",
      "gremio retro",
      "grêmio retro",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/gremio/94-95-02-rt/uni0.jpg",
      "/images/brasil/serie-a/gremio/94-95-02-rt/uni1.jpg",
      "/images/brasil/serie-a/gremio/94-95-02-rt/uni2.jpg",
      "/images/brasil/serie-a/gremio/94-95-02-rt/uni3.jpg",
      "/images/brasil/serie-a/gremio/94-95-02-rt/uni4.jpg",
    ],
  },
  {
    id: 33,
    pais: "brasil",
    liga: "serie-a",
    time: "gremio",
    nome: "Grêmio - Jaqueta (Preta/Azul)",
    aliases: [
      "gremio",
      "grêmio",
      "tricolor",
      "imortal",
      "jaqueta",
      "gremio jaqueta",
      "grêmio jaqueta",
    ],
    tipo: "masculino",
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/gremio/jpae/uni0.jpg",
      "/images/brasil/serie-a/gremio/jpae/uni1.jpg",
      "/images/brasil/serie-a/gremio/jpae/uni2.jpg",
      "/images/brasil/serie-a/gremio/jpae/uni3.jpg",
      "/images/brasil/serie-a/gremio/jpae/uni4.jpg",
    ],
  },
];

export default gremio;
